import { API_TYPES } from "@src/appV2/api/apiTypes";
import { ShiftCancellationReasonTypes } from "@src/appV2/ShiftLogs/api/ShiftCancellationReasonTypes";
import { z } from "zod";

import { ShiftLogAction, ShiftLogSubAction } from "./ShiftLogAction";

export const shiftLogSchema = z.object({
  type: z.literal(API_TYPES.shiftLog),
  id: z.string(),
  relationships: z
    .object({
      worker: z
        .object({
          data: z.object({
            id: z.string(),
            type: z.literal(API_TYPES.worker),
          }),
        })
        .optional(),
      shift: z
        .object({
          data: z.object({
            id: z.string(),
            type: z.literal(API_TYPES.shift),
          }),
        })
        .optional(),
    })
    .optional(),
  attributes: z
    .object({
      actionDetails: z
        .object({
          action: z.union([z.nativeEnum(ShiftLogAction), z.string().min(1)]),
          subAction: z.union([z.nativeEnum(ShiftLogSubAction), z.string().min(1)]).optional(),
          reason: z.object({
            type: z.nativeEnum(ShiftCancellationReasonTypes).nullable(),
            description: z.string().optional(),
          }),
          notes: z.array(z.string()),
          performedBy: z.object({
            id: z.string().optional(),
            type: z.string(),
            name: z.string(),
          }),
        })
        .partial()
        .optional(),
      leadTime: z.number(),
      pay: z
        .object({
          total: z.number(),
        })
        .partial(),
      rateChangeReasons: z
        .object({
          previousRate: z.number(),
          currentRate: z.number(),
          currentReason: z.string(),
        })
        .optional(),
      timeChangeAttributes: z
        .object({
          previousTime: z.number().optional(),
          currentTime: z.number().optional(),
          reason: z.string().nullable().optional(),
          newStart: z.string().nullable().optional(),
          newEnd: z.string().nullable().optional(),
        })
        .optional(),
      originalStart: z.string().nullable().optional(),
      originalEnd: z.string().nullable().optional(),
      searchMode: z.string(),
      eventAt: z.string(),
      expectedArrival: z
        .object({
          targetArrivalTime: z.string(),
          leadTimeInMinutes: z.number(),
          distanceInMeters: z.number(),
          durationInMinutes: z.number(),
          provider: z.string(),
          leadTimeCategory: z.enum(["SHORT", "LONG"]),
        })
        .optional(),
      clockInAt: z.string().optional(),
      workerType: z.string(),
      workerName: z.string(),
    })
    .partial()
    .optional(),
  meta: z
    .object({
      isOriginalWorker: z.boolean().optional(),
    })
    .optional(),
});

export type ShiftLogSchema = z.infer<typeof shiftLogSchema>;
